export const sortOrders = {
  ASCENDING: "asc",
  DESCENDING: "desc"
}

export const commentTypes = {
  COMMENT: "comment",
  REPLY: "reply"
}

export const COMMENTS_LIMIT = 10
export const REPLIES_LIMIT = 10
